// Libraries
import { loader } from 'graphql.macro';
import { useLazyQuery } from 'react-apollo';
import { useState } from 'react';
// import { useSelector } from 'react-redux';
// import { get } from 'lodash';

// GraphQL
const getCollectionAssetsQuery = loader('../graphql/queries/getCollectionAssets.gql');

export const useGetCollectionAssets = id => {
  // const user = useSelector(state => get(state, 'session'));
  const [assets, setAssets] = useState([]);
  const [query, { loading }] = useLazyQuery(getCollectionAssetsQuery, {
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'cache-first',
    onCompleted: data => {
      if (data?.collection) {
        setAssets(data.collection?.assets)
      }
    },
    onError: error => console.error(error)
  });

  // useEffect(() => {
  //   if (user.id) {
  //     query({ variables: { id } });
  //   }
  // }, [user]);

  const getAssets = () => {
    query({ variables: { id } });
  };

  return {
    loading,
    assets,
    getAssets
  };
};
